import { Link } from "react-router-dom"
import { useEditSiteMutation, useGetPagesQuery } from "../../Redux/Apis/panelApi"
import Loading from "../../Layouts/Loading"
import Error from "../../Layouts/Error"
import { useEffect, useState } from "react"
import { FormText } from "../../Components/Form/FormText"
import { FormImage } from "../../Components/Form/FormImage"
import { Media } from "../../Components/Media"
import { FormTexterea } from "../../Components/Form/FormTexterea"

export default function EditPages(){
    let [resetKey,setKey] = useState(0)
    const {
        data,
        isLoading,
        isSuccess,
        isError,
        error,
    } = useGetPagesQuery({})
    const [edit, {isLoading: isLoadingEdit}] = useEditSiteMutation()
    const [errorMsg, setErrorMsg] = useState<any>(false)
    const [formState, setFormState] = useState({
        status: '',
        name: '',
        logo: '',
        menu: ''
    })

    const handleChange = ({ target: { name, value, checked },} : React.ChangeEvent<any> ) =>
        {setFormState((prev:any) => (name === "status" ? { ...prev , [name]: checked ? 'ACTIVE' : 'DEACTIVE' } : { ...prev,[name]: value } ))}

    const onSubmit = async (e : React.FormEvent) => {
        e.preventDefault()
        try {
            await edit(formState)
            setKey(resetKey + 1)
            setErrorMsg(false)
        } catch (err:any){
            console.log(err);
            const message = !err.data ? '' : Array.isArray(err.data.message) ? err.data.message[0] : err.data.message
            setErrorMsg(message)                                     
        }
    }

    useEffect(() => {
        setFormState(data);
    }, [data])

    if(isLoading)
        return <Loading/>

    else if(isError)
        return <Error data={error}/>

    else if(isSuccess) {
      return (
        <div className="container-fluid">
            <Media />
            <div className="row mt-1 p-0">
                <div className="col-lg-3 col-md-4 m-0">
                    <div className="card">
                        <div className="card-header">
                            <Link to="/" className="btn btn-secondary float-start"><span className="zmdi zmdi-chevron-right"></span> </Link>
                            <h5 className="float-start mt-2 ms-2">
                                 ویرایش قالب
                            </h5>
                            <button id="submitButton" className="btn btn-success float-end" type="submit" form='editForm' disabled={isLoadingEdit}>ذخیره</button>
                        </div>

                        <div className="card-body">
                            { data.general && <div className="accordion accordion-flush border rounded mx-0 py-1" id="editAccordion">
                                <div className="accordion-item">
                                    <h2 className="accordion-header" id={`flush-heading`}>
                                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target={`#flush-collapse`} aria-expanded="false" aria-controls="flush-collapseOne">
                                            <span className="zmdi zmdi-settings zmdi-hc-lg me-2"></span>
                                            تنظیمات کلی
                                        </button>
                                    </h2>
                                    <div id={`flush-collapse`} className="accordion-collapse collapse disable" aria-labelledby={`flush-heading`} data-bs-parent="#editAccordion">
                                        <div className="accordion-body">

                                            {errorMsg && <div className="alert alert-danger" role="alert">
                                                {errorMsg}
                                            </div>}

                                            <form id='editForm' onSubmit={onSubmit}>
                                                <div className="form-check form-switch mb-3">
                                                    <input className="form-check-input" onChange={handleChange} name="status" type="checkbox" role="switch" id={`statusCheck`} defaultChecked={data.general.status === 'ACTIVE'} />
                                                    <label className="form-check-label" htmlFor={`statusCheck`}>وضعیت سایت</label>
                                                </div>
                                                <FormText _key="name" name="نام سایت" value={data.general.name} input="name" change={handleChange}/>
                                                <FormTexterea _key="description" name="توضیحات سایت" value={data.general.description} input="description" change={handleChange}/>
                                                <FormImage _key='logo' name='لوگو سایت' value={data.general.logo} input='logo' change={handleChange} url={data.url}/>
                                                {/* <FormList _key='menu' name='منوی سایت' value={data.general.menu} input='menu' change={handleChange}/> */}
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            }
                            { data.pages.map((value:any, index:number) => 
                                <div className="col border rounded mx-0 my-2 p-3" key={index}>
                                    <div className="row">
                                    <div className="col float-start">
                                        <p className="mt-1 mb-0">{`صفحه ${value.name}`}</p>
                                    </div>
                                    <div className="col float-end text-end">
                                        <Link className="btn btn-primary" to={'/edit/' + value.key}>
                                            ویرایش  
                                            <span className="zmdi zmdi-chevron-left ms-2"></span>
                                        </Link>
                                    </div>
                                    </div>
                                </div>
                            )}
                            <p className="text-secondary mt-4">* با بستن تب محتوا اتوماتیک ذخیره میشود.</p>
                        </div>
                    </div>  
                    
                </div>
                <div className="col-lg-9 col-md-8 m-0 d-none d-sm-block">
                    <iframe id="myIframe" title="SITE" key={resetKey} src={data.url} className="d-block" style={{overflow:"hidden",height:"100vh",width:"100%"}}></iframe>
                </div>
            </div>
        </div>
    )
    }

    else return <></>
}